import APIService from '@/services/APIService.js';

export default {
  getAll() {
    return APIService.apiCall().get('/perfis/get-all');
  },
  getModulosPerfis(perfilIdOpicional) {
    const url = perfilIdOpicional ? `/perfis/get-modulos-perfis/${perfilIdOpicional}` : '/perfis/get-modulos-perfis';
    return APIService.apiCall().get(url);
  },
  getModulosLiberados() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/perfis/get-modulos-perfis-liberados')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  },
  atualizarStatus(id, novoStatus) {
    return APIService.apiCall().get(`/perfis/alteraStatus/${id}/${novoStatus}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/perfis/salvar/${postData.id}`, JSON.stringify(postData));
  }
};
